module.exports = {
    // API_URL: 'http://192.168.31.31:8008/QamtuUser/public/api/'
    API_URL: 'https://api.e.qamtu.kz/api/'
}